import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { COLORS } from "@/utils/constants/colors";

interface ColorPickerProps {
    color: string;
    name: string;
    setHeaderBg?: (color: string) => void;
    setHeaderText?: (color: string) => void;
    setButtonBg?: (color: string) => void;
    setButtonText?: (color: string) => void;
    className?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = (props) => {
    const [showPicker, setShowPicker] = useState(false);
    const [color, setColor] = useState(props.color);

    const onClick = () => {
        setShowPicker(!showPicker);
    };

    const onClose = () => {
        setShowPicker(false);
    };

    const onChange = (newColor: { hex: string }) => {
        setColor(newColor.hex);
        switch (props.name) {
            case "headerBg":
                props.setHeaderBg?.(newColor.hex);
                break;
            case "headerText":
                props.setHeaderText?.(newColor.hex);
                break;
            case "buttonBg":
                props.setButtonBg?.(newColor.hex);
                break;
            case "buttonText":
                props.setButtonText?.(newColor.hex);
                break;
            default:
                break;
        }
    };

    const swatchStyle: React.CSSProperties = {
        padding: "6px",
        cursor: "pointer",
        display: "inline-block",
        boxShadow: "0 0 0 1px rgba(0,0,0,.2)",
        borderRadius: "50%",
        height: "40px",
        width: "40px",
        justifyContent: "center",
        alignItems: "center",
        color: COLORS.white,
        background: color || COLORS.white,
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.06em",
        flexShrink: 0,
    };

    return (
        <div className="gs-color-picker">
            <div style={swatchStyle} onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onClick()} />
            {showPicker ? (
                <>
                    <button
                        type="button"
                        className="gs-color-picker__backdrop"
                        onClick={onClose}
                        aria-label="Close color picker"
                    />
                    <div className="gs-color-picker__popover">
                        <SketchPicker color={color} onChange={onChange} />
                    </div>
                </>
            ) : null}
        </div>
    );
};

export default ColorPicker;
